import React from "react";
import { useNavigate } from "react-router-dom";
import { Container, Card } from "react-bootstrap";
import { useState, useContext, useEffect } from "react";
import { AuthContext } from "../../App";
import { getUser, getUserProduct, getReservation } from "../../utils/api";
import { authentication } from "../../utils/config";
import "./main.css";
import "./../../components/button/button.css";
import "./../../components/background/background.css";
import Image from "../../assets/background.png";
import Header from "../../components/header/header";
import Swal from "sweetalert2";
import Error from "../error/error";

const Main = () => {
  const navigate = useNavigate();
  const [clinicName, setClinicName] = useState("");
  const [clinicCode, setClinicCode] = useState("");
  const [isVip, setIsVip] = useState("元大之友");
  const [createDate, setCreateDate] = useState("");
  const [product, setProduct] = useState(false);
  const [reserv, setReserv] = useState(false) ;
  const lineProfile = useContext(AuthContext);

  useEffect(() => {
    // check line account
    var flag = true;
    const auth = async () => {
      const response = await authentication(lineProfile.userId, null);
      if (response.error || response.data === "no lineId")
        return navigate("/error");
      else if (
        response.data === "no user" ||
        response.data === "no vertification"
      )
        return navigate("/email");
      else if (response.data === "vertified") return navigate("/register");
      flag = false;
    };

    //get User data
    const fetchUserData = async () => {
      if (flag) return;
      const response = await getUser(lineProfile);
      if (response.error) {
        await Swal.fire({
          title: "系統錯誤",
          text: JSON.stringify(response.data),
          icon: "error",
        });
        flag = true ;
      } else if (response.data === "not found the user") {
        await Swal.fire({
          title: "帳號不存在",
          text: "請註冊帳號",
          icon: "error",
        });
        flag = true ;
      } else {
        setClinicName(response.data.clinic.name);
        setClinicCode(response.data.clinic.code);
        setCreateDate(response.data.createdAt.split("T")[0]);
        if (response.data.clinic.vip) setIsVip("⭐元大之友");
      }
      
    };


    //call getUserProduct api
    const fetchUserProduct = async () => {
      if (flag) return;
      const response = await getUserProduct(lineProfile);
      if (response.error) {
        await Swal.fire({
          title: "系統錯誤",
          text: JSON.stringify(response.data),
          icon: "error",
        });
        flag = true ;
      } else if (response.data === "not found the user") {
        await Swal.fire({
          title: "帳號不存在",
          text: "請註冊帳號",
          icon: "error",
        });
        flag = true ;
      } else if (response.data === "not found any product") {
        setProduct(false);
      } else {
        console.log(response.data.length) ;
        setProduct(response.data.length);
      }
    };

    // get resrevation
    const fetchReserv = async () => {
      if (flag) return;
      const response = await getReservation(lineProfile);
      if (response.error) return navigate("/error");
      else if (
        response.data === "not found reservation" ||
        response.data.reservations.length === 0
      )
        setReserv(false);
      else {
        setReserv(response.data.reservations.length);
      }
    };



    const combine = async () => {
      await auth();
      await fetchUserData();
      await fetchUserProduct() ;
      await fetchReserv();
    };
    combine();
  }, []);


  return (
    <Container
      fluid
      className=" d-flex flex-column  align-items-center backgroundStyle"
      style={{ backgroundImage: `url(${Image})` }}
    >
      <div className="w-100 mt-3">
        <Header title="會員專區" style={{ width: "100%" }} />
      </div>

      <div className="w-100 main-member-title">
        <p className=" mb-0 main-member-title-name">
          <b>{clinicName}</b>
        </p>
        <p className="main-member-title-code">
          <b>診所會員編號: {clinicCode}</b>
        </p>
      </div>
      <div style={{ width: "90%" }}>
        <Card
          className="mb-3 shadow-lg text-white"
          style={{ backgroundColor: "#00867F", cursor: "pointer" }}
          onClick={() => {
            navigate("/memberright");
          }}
        >
          <Card.Body>
            <Card.Text>
              <p className="h3">
                <b>{isVip}</b>
              </p>
              <div className="d-flex justify-content-between">
                <p className="mb-0" style={{ fontSize: "15px" }}>
                  <b>加入日期: {createDate}</b>
                </p>
                <p className="mb-0" style={{ fontSize: "15px" }}>
                  查看會員權益
                </p>
              </div>
            </Card.Text>
          </Card.Body>
        </Card>
      </div>
      <div className="mt-4"></div>
      <div
        className="cell"
        onClick={() => {
          navigate("/memberdata");
        }}
      >
        <span>
          <b>會員資料</b>
        </span>
        <span>
          <b className="main-color">更改</b>
        </span>
      </div>
  
      <hr  className="main-hr"/>
      <div
        className="cell "
        onClick={() => {
          navigate("/memberrecord");
        }}
      >
        <span className="m-0 p-0">
          <b >產品購買紀錄</b>
          {product && 
          (<>
            <br/><b className="main-hint">目前有 {product} 項登錄項目</b>
          </>)
          }
        </span>
        <span>
          <b className="main-color">查看</b>
        </span>
      </div>

      <hr className="main-hr"/>
      <div
        className="cell"
        onClick={() => {
          navigate("/reservationmenu");
        }}
      >
        <span>
          <b>線上預約保養</b>
          {reserv && 
          (<>
            <br/><b className="main-hint">尚有 {reserv} 次未完成預約</b>
          </>)}
        </span>
        <span>
          <b className="main-color">前往</b>
        </span>
      </div>

      <hr className="main-hr"/>
      <a className="cell" href="https://forms.gle/tGKqj8fA3QaY1DoMA">
        <span>
          <b style={{ color: "black" }}>售後問券調查</b>
        </span>
        <span>
          <b className="main-color">前往</b>
        </span>
      </a>
 
      <hr className="main-hr"/>
      <div style={{ width: "70%" }} className="text-center mb-3 mt-3">
        <p className="mt-0 mb-1">元大牙科儀器股份有限公司</p>
        <div className="d-flex-main">
          <p className="mb-3">(04)2350-5000</p><b>|</b>
          <p className="mb-3">(02)2581-6703</p>
        </div>
      </div>

     
    </Container>
  );
};

export default Main;
